"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFlattenNestedKeyObject = void 0;
const error_1 = require("../error");
const internalFlattenObjectByKey = (obj, { joinKey, manageArrayValue, }, prefixArr) => {
    const inputs = {};
    for (const [key, value] of Object.entries(obj)) {
        const typeofKey = typeof key;
        (0, error_1.finleyAssert)(typeofKey === 'string', `Trying to flatten non-string key [key:${key}] [type:${typeofKey}]`);
        (0, error_1.finleyAssert)(!key.includes(joinKey), `[key:${key}] already incorrectly includes [joinKey:${joinKey}]`);
        // Can revisit below assertion when this util needs to consider these scenarios
        const typeofValue = typeof value;
        (0, error_1.finleyAssert)(!['function', 'bigint', 'symbol'].includes(typeofValue), `${typeofValue} is not supported as flattened values [key:${key}]`);
        if (Array.isArray(value)) {
            (0, error_1.finleyAssert)(manageArrayValue !== 'error', `Arrays are not allowed as flattened values [key:${key}] [value:${value}]`);
            if (manageArrayValue === 'ignore') {
                continue;
            }
        }
        prefixArr.push(key);
        // Note: `null` and `arrays` are "object's" so also need to verify
        // If avoiding arrays, this would have exited already per above
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            const flattenedObject = internalFlattenObjectByKey(value, { joinKey, manageArrayValue }, prefixArr);
            for (const [flattenedKey, flattenedValue] of Object.entries(flattenedObject)) {
                inputs[flattenedKey] = flattenedValue;
            }
        }
        else {
            inputs[prefixArr.join(joinKey)] = value;
        }
        prefixArr.pop();
    }
    return inputs;
};
const generateFlattenNestedKeyObject = (obj, { joinKey = '.', manageArrayValue = 'error', } = {}) => {
    return internalFlattenObjectByKey(obj, { joinKey, manageArrayValue }, []);
};
exports.generateFlattenNestedKeyObject = generateFlattenNestedKeyObject;
//# sourceMappingURL=generateFlattenNestedKeyObject.js.map